import React, { useState, useEffect } from "react";

import * as Yup from "yup";
import InputField from "../../../common/InputField";
import { getUserIdFromLocalStorage } from "../../../utils/Utilities";
import {
  Box,
  Card,
  FormHelperText,
  Grid,
  InputLabel,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Formik, Form } from "formik";
import { toast } from "react-hot-toast";
import {
  LinkButton,
  PrimaryButton,
  SecondaryButton,
} from "../../../common/Buttons";

import "./Declaration.scss";
import {
  getOrganDonationData,
  postOrganDonationData,
} from "../../../services/documentServices";
import { useTranslation } from "react-i18next";
import { Circles } from "react-loader-spinner";

const Declaration = ({ next, setButtonDisabled }) => {
  const { t } = useTranslation();
  let uID = getUserIdFromLocalStorage();
  const [data, setData] = useState(null);
  const [initialValues, setInitialValues] = useState({
    declarationType: 0,
    declarationDescription_1: "",
    declarationDescription_2: "",
    name: "",
    street: "",
    houseNumber: 0,
    city: "",
    postCode: 0,
    phone: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const validate = Yup.object({
    name: Yup.string().nullable(),
    street: Yup.string()
      .matches(/^[a-zA-Z-.äöüÄÖÜß ]*$/g, t("validation-p1"))
      .nullable(),
    house_number: Yup.number().nullable(),
    city: Yup.string().nullable(),
    postCode: Yup.number().nullable(),
    phone: Yup.number().nullable(),
  });

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));

  async function fetchData() {
    setIsLoading(true);
    try {
      const result = await getOrganDonationData(uID);
      if (result?.success && result?.payLoad) {
        setData(result.payLoad);
        if (result?.payLoad) {
          const {
            organDonationAuthorizePerson,
            declarationType,
            declarationDescription,
          } = result.payLoad;
          setInitialValues((pre) => ({
            ...pre,
            ...{
              ...organDonationAuthorizePerson,
            },
            declarationType,
            declarationDescription_1:
              declarationType === 2 ? declarationDescription : "",
            declarationDescription_2:
              declarationType === 3 ? declarationDescription : "",
          }));
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    fetchData();
  }, []);

  const handleSubmit = async (values) => {
    setButtonDisabled(true);
    const {
      declarationType,
      declarationDescription,
      declarationDescription_1,
      declarationDescription_2,
      stepStatus,
      ...rest
    } = values;
    const payload = {
      ...data,
      organDonationAuthorizePerson:
        declarationType === 5
          ? {
              ...rest,
              stepStatus:
                rest.name !== undefined &&
                rest.street !== undefined &&
                rest.houseNumber !== undefined &&
                rest.city !== undefined &&
                rest.postCode !== undefined &&
                rest.phone !== undefined
                  ? 2
                  : rest.name === undefined &&
                    rest.street === undefined &&
                    rest.houseNumber === undefined &&
                    rest.city === undefined &&
                    rest.postCode === undefined &&
                    rest.phone === undefined
                  ? 0
                  : 1,
            }
          : null,
      declarationType,
      declarationDescription:
        declarationType === 2
          ? declarationDescription_1
          : declarationDescription_2,
    };

    const result = await postOrganDonationData(payload, uID);
    if (result?.success) {
      // toast.success(
      //   t(
      //     result?.message
      //       .toLowerCase()
      //       .replaceAll(" ", "-")
      //       .replaceAll("/", "-")
      //       .replaceAll(",", "")
      //       .replaceAll("'", "")
      //   )
      // );
      next();
    }
    setButtonDisabled(false);
  };

  const handleSkipFun = async () => {
    next();
  };

  const handleSetDeclarationType = (setFieldValue, value) => {
    setFieldValue("declarationType", value);
  };
  return (
    <Paper className="declaration summary-table documents-card-height">
      {isLoading ? (
        <Box component="div" className="loader-container">
          <Circles color="#dfc8db" height={80} width={80} />
        </Box>
      ) : (
        <Grid container>
          <Grid
            item
            lg={7}
            md={6}
            sm={12}
            xs={12}
            className="outer outer-pt-10"
          >
            <Typography
              variant="h4"
              fontWeight={"bold"}
              color="color.magentaDark1"
            >
              {t("od-heading")}
            </Typography>
            <Formik
              initialValues={initialValues}
              enableReinitialize
              validationSchema={validate}
              onSubmit={(values) => handleSubmit(values)}
            >
              {(formik) => (
                <Form id="form_submit" onSubmit={formik.handleSubmit}>
                  <FormHelperText
                    sx={{ mt: 4, display: "block" }}
                    component={"span"}
                    className="label-helper-text"
                  >
                    {t("od-text")}
                  </FormHelperText>
                  <br />
                  <div
                    className="radio-button"
                    name="declarationType"
                    onClick={() => {
                      formik.resetForm({
                        values: {
                          ...formik.values,
                          declarationDescription_1: "",
                          declarationDescription_2: "",
                          name: "",
                          street: "",
                          houseNumber: 0,
                          city: "",
                          postCode: 0,
                          phone: "",
                        },
                      });
                      handleSetDeclarationType(formik.setFieldValue, 1);
                    }}
                  >
                    <label
                      className="checkbox-custom-label"
                      style={{
                        backgroundColor:
                          formik.values.declarationType === 1
                            ? "#f4ecf3"
                            : "#ffff",
                      }}
                    >
                      {t("od-p1")}
                    </label>
                  </div>
                  <br />
                  <div
                    className="radio-button"
                    name="declarationType"
                    onClick={() => {
                      formik.resetForm({
                        values: {
                          ...formik.values,
                          declarationDescription_2: "",
                          name: "",
                          street: "",
                          houseNumber: 0,
                          city: "",
                          postCode: 0,
                          phone: "",
                        },
                      });
                      handleSetDeclarationType(formik.setFieldValue, 2);
                    }}
                  >
                    <label
                      className="checkbox-custom-label"
                      style={{
                        backgroundColor:
                          formik.values.declarationType === 2
                            ? "#f4ecf3"
                            : "#ffff",
                      }}
                    >
                      {t("od-p2")}
                      <InputField
                        fullWidth
                        variant="standard"
                        name="declarationDescription_1"
                        placeholder={t("please-write")}
                        type="text"
                      />
                    </label>
                  </div>

                  <br />

                  <div
                    className="radio-button"
                    name="declarationType"
                    onClick={() => {
                      formik.resetForm({
                        values: {
                          ...formik.values,
                          declarationDescription_1: "",
                          name: "",
                          street: "",
                          houseNumber: 0,
                          city: "",
                          postCode: 0,
                          phone: "",
                        },
                      });
                      handleSetDeclarationType(formik.setFieldValue, 3);
                    }}
                  >
                    <label
                      className="checkbox-custom-label"
                      style={{
                        backgroundColor:
                          formik.values.declarationType === 3
                            ? "#f4ecf3"
                            : "#ffff",
                      }}
                    >
                      {t("od-p3")}
                      <InputField
                        fullWidth
                        variant="standard"
                        name="declarationDescription_2"
                        placeholder={t("please-write")}
                        type="text"
                      />
                    </label>
                  </div>
                  <br />
                  <div
                    className="radio-button"
                    name="declarationType"
                    onClick={() => {
                      formik.resetForm({
                        values: {
                          ...formik.values,
                          declarationDescription_1: "",
                          declarationDescription_2: "",
                          name: "",
                          street: "",
                          houseNumber: 0,
                          city: "",
                          postCode: 0,
                          phone: "",
                        },
                      });
                      handleSetDeclarationType(formik.setFieldValue, 4);
                    }}
                  >
                    <label
                      className="checkbox-custom-label"
                      style={{
                        backgroundColor:
                          formik.values.declarationType === 4
                            ? "#f4ecf3"
                            : "#ffff",
                      }}
                    >
                      {t("od-p4")}
                    </label>
                  </div>
                  <br />
                  <div
                    className="styled-form"
                    style={{
                      backgroundColor:
                        formik.values.declarationType === 5
                          ? "#f4ecf3"
                          : "#ffff",
                      border:
                        formik.values.declarationType === 5
                          ? "3px solid #c298bb"
                          : "1px solid #a5a5a5",
                    }}
                    onClick={() => {
                      formik.resetForm({
                        values: {
                          ...formik.values,
                          declarationDescription_1: "",
                          declarationDescription_2: "",
                        },
                      });
                      handleSetDeclarationType(formik.setFieldValue, 5);
                    }}
                  >
                    <Typography fontWeight={"bold"} color="color.magentaDark1">
                      {t("od-p5")}
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item lg={12}>
                        <InputField
                          fullWidth
                          variant="standard"
                          label={t("name,-first-name")}
                          // placeholder="Martina Müller"
                          InputLabelProps={{ shrink: true }}
                          name="name"
                          type="text"
                        />
                      </Grid>
                      <Grid item xl={8} lg={8} md={8} sm={12}>
                        <InputField
                          fullWidth
                          variant="standard"
                          label={t("input-6")}
                          // placeholder="Turmbergstraße"
                          InputLabelProps={{ shrink: true }}
                          name="street"
                          type="text"
                        />
                      </Grid>
                      <Grid item xl={4} lg={4} md={4} sm={12}>
                        <InputField
                          fullWidth
                          variant="standard"
                          label={t("input-7")}
                          // placeholder="22"
                          InputLabelProps={{ shrink: true }}
                          name="houseNumber"
                          type="number"
                        />
                      </Grid>
                      <Grid item xl={8} lg={8} md={8} sm={12}>
                        <InputField
                          fullWidth
                          variant="standard"
                          label={t("input-8")}
                          // placeholder="Karlsruhe"
                          InputLabelProps={{ shrink: true }}
                          name="city"
                          type="text"
                        />
                      </Grid>
                      <Grid item xl={4} lg={4} md={4} sm={12}>
                        <InputField
                          fullWidth
                          variant="standard"
                          label={t("input-9")}
                          // placeholder="76227"
                          InputLabelProps={{ shrink: true }}
                          name="postCode"
                          type="number"
                        />
                      </Grid>
                      <Grid item lg={12}>
                        <InputField
                          fullWidth
                          variant="standard"
                          label={t("input-4")}
                          // placeholder="01774251951"
                          InputLabelProps={{ shrink: true }}
                          name="phone"
                          type="number"
                        />
                      </Grid>
                    </Grid>
                  </div>
                </Form>
              )}
            </Formik>
          </Grid>
        </Grid>
      )}
    </Paper>
  );
};

export default Declaration;
